import ListActions from "modules/list/actions";
import api from "services/api";
import store from "services/store";
import { getCluster } from "state/cluster/selectors/details";
import { DeploymentSchema } from "utils/schemas";

export const DEPLOYMENTS_MODULE = "deployments";

export const deploymentsListingActions = new ListActions({
  async fetchData({ filterBy = [] } = {}) {
    const cluster = getCluster(store.getState());

    const data = await api.post(
      `v1/dashboard/spectroclusters/${cluster.metadata.uid}/workloads/deployment`,
      {
        filter: {
          namespaces: filterBy,
        },
      }
    );

    return {
      items: (data?.deployments || []).sort((deploy1, deploy2) =>
        deploy1.metadata.namespace > deploy2.metadata.namespace ? 1 : -1
      ),
    };
  },
  initialQuery: () => ({
    filterBy: [],
  }),
  schema: [DeploymentSchema],
});
